import { ColorRGBA64 } from '@microsoft/fast-colors';
/**
 * Gets rgb(r, g, b, a) ready for CSS usages.
 *
 * @internal
 */
export const getWebRGBA = (rgb, alpha = 1.0) => {
    const rgba = new ColorRGBA64(rgb.r, rgb.g, rgb.b, alpha);
    return rgba.toStringWebRGBA();
};
